import ManualDocumentSigningContainer from "./ManualDocumentSigningContainer";
import ManualDocumentSigningStore from "./ManualDocumentSigningStore";

export default ManualDocumentSigningStore(ManualDocumentSigningContainer);